<div class="best-projects-container">
    <div class="row">
        <div class="col m12 s12 title-container">
            <h1>MIS PROYECTOS</h1>
        </div>

    </div>
    <div class="row projects-container">
        <div class="col m6 s12 project">
            <img src="../../../assets/images/bricofem.org.gif" alt="">
            <div class="tags-container">
                <ul class="tags">
                    <li class="tag">Angular</li>
                    <li class="tag">SCSS</li>
                    <li class="tag">Bootstrap</li>
                    <li><a href="https://www.bricofem.org/" class="tag demo_link" target="_blank">Demo</a></li>
                </ul>

            </div>
            <div class="description-container">

            </div>

        </div>
        <div class="col m6 s12 project">
            <img src="../../../assets/images/api-cencosud.gif" alt="">
            <div class="tags-container">
                <ul class="tags">
                    <li class="tag">NodeJs</li>
                    <li class="tag">Javascript</li>
                    <li class="tag">Express</li>
                    <li class="tag">MongoDB</li>
                    <li><a href="https://github.com/CaritoDasilva/cenco_api_test" class="tag demo_link"
                            target="_blank">Code</a></li>
                </ul>
            </div>
            <div class="description-container">

            </div>

        </div>
        <div class="col m6 s12 project">
            <img src="../../../assets/images/color-picker.gif" alt="">
            <div class="tags-container">
                <ul class="tags">
                    <li class="tag">Angular</li>
                    <li class="tag">Javascript</li>
                    <li class="tag">Typescript</li>
                    <li class="tag">Angular Material</li>
                    <li><a href="https://color-picker-61f35.web.app/" class="tag demo_link" target="_blank">Demo</a>
                    </li>
                    <li><a href="https://github.com/CaritoDasilva/color-picker" class="tag demo_link"
                            target="_blank">Code</a></li>
                </ul>
            </div>
            <div class="description-container">

            </div>

        </div>
    </div>
</div>